// API Configuration
export const API_CONFIG = {
  BASE_URL: "https://admin-barcode-stg.eatsy.vn/api",
  TIMEOUT: 30000, // 30 seconds
  RETRY_ATTEMPTS: 3,
} as const;

// Common API endpoints
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: "/auth/login",
    ME: "/v1/auth/me",
  },
  USERS: {
    BASE: "/users",
    CREATE_ADMIN: "/users/create-admin",
    TOGGLE_STATUS: (id: string) => `/users/${id}/toggle-status`,
    BY_ID: (id: string) => `/users/${id}`,
  },
  BRANDS: {
    BASE: "/brands",
    ALL: "/brands/all",
    SEARCH: "/brands/search",
    BY_STATUS: (isActive: boolean) => `/brands/status/${isActive}`,
    BY_ID: (id: string) => `/brands/${id}`,
  },
  CATEGORIES: {
    BASE: "/categories",
    ACTIVE: "/categories/active",
    LIST: "/categories/list",
    BY_ID: (id: string) => `/categories/${id}`,
  },
  FOODS: {
    BASE: "/foods",
    BY_ID: (id: string) => `/foods/${id}`,
    BY_BARCODE: (barcode: string) => `/foods/barcode/${barcode}`,
    CHECK_BARCODE: (barcode: string) => `/foods/check-barcode/${barcode}`,
    DEACTIVATE: (id: string) => `/foods/${id}/deactivate`,
  },
  FOOD_SUBMISSIONS: {
    BASE: "/food-submissions",
    PENDING: "/food-submissions/pending",
    STATS: "/food-submissions/stats",
    BY_ID: (id: string) => `/food-submissions/${id}`,
    REVIEW: (id: string) => `/food-submissions/${id}/review`,
    TRIGGER_AI: (id: string) => `/food-submissions/${id}/trigger-ai`,
  },
} as const;

// Common headers
export const getCommonHeaders = (): Record<string, string> => ({
  "Content-Type": "application/json",
});

// Authentication headers
export const getAuthHeaders = (): Record<string, string> => {
  const token = localStorage.getItem("accessToken");
  if (!token) {
    throw new Error("No access token found. Please login first.");
  }

  return {
    ...getCommonHeaders(),
    Authorization: `Bearer ${token}`,
  };
};
